import React, { ReactNode, useEffect, useState } from 'react';
import Button from '../../../../../components/envago/Button/Button';
import Icon from '../../../../../components/envago/Icon/Icon';
import { ImagePreview } from '../../../../../components/envago/ImagePreview';
import { RemoteResult, RemoteResultConfiguration } from '../../index.types';
import { RemoteResultDialog } from '../RemoteResultDialog';
import { MAX_READING_IMAGES } from '../../../../../constants/ReadingImageLimits';
import { isMobilePlatform } from '../../../../../helper/PlatformHelper';

interface RemoteResultCameraUploadProps {
    triggerText?: ReactNode;
    primary?: boolean;
    disabled?: boolean;
    config: RemoteResultConfiguration;
    images: Array<string>;
    onRemoteResultReceived: (result: RemoteResult | undefined, imageBase64: string) => void;
    allowGallery?: boolean;
    onDelete?: (index: number) => void;
    deleteDisabled?: boolean;
    aiEnabled: boolean;
}

const RemoteResultCameraUpload = ({
    config,
    images,
    primary,
    disabled,
    triggerText = 'Ablesefoto',
    onRemoteResultReceived,
    allowGallery = false,
    onDelete,
    deleteDisabled,
    aiEnabled,
}: RemoteResultCameraUploadProps) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        return () => {
            setOpen(false);
        };
    }, []);

    if (!isMobilePlatform) {
        return null;
    }

    const maxReached = images.length >= MAX_READING_IMAGES;

    return (
        <>
            <Button
                primary={primary}
                ghost={!primary}
                disabled={disabled || maxReached}
                block={true}
                onClick={() => {
                    setOpen(true);
                }}
            >
                <Icon path={Icon.Path.mdiCamera} /> {triggerText}
            </Button>
            <RemoteResultDialog open={open} onOpenChange={setOpen} config={config} allowGallery={allowGallery} onChange={onRemoteResultReceived} aiEnabled={aiEnabled} />
            <ImagePreview data={images} onDelete={onDelete} disabled={deleteDisabled} />
        </>
    );
};

export default RemoteResultCameraUpload;
